import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";

function FeaturesHome() {
  const navto =useNavigate()
  // onscrollanimation start
  // const anime = {
  //   visible: {
  //     opacity: 1,
  //     y: 0,
  //     transition: { ease: "easeInOut", duration: 0.9 },
  //   },
  //   hidden: { opacity: 0, y: -100 },
  // };
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 1.1 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const control1 = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  useEffect(() => {
    if (inView) {
      control1.start("visible");
    } 
  }, [control1, inView]);
  // onscrollanimation end
  return (
    <div className="row secpad align-items-center">
      <motion.div
        className="col-xxl-7 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 features-home1"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      >
        <h6>Features</h6>
        <h2>
          Best Features Provided by <span>Zappitech</span>
        </h2>
        <p>
          Our Smart Feature Zappitech is invoicing mobile app providers with the
          aim of making billing easier. It can process more quickly and be more
          receptive to Indian MSME business teams. This would enable them to
          concentrate more on their business activities and forecasts while also
          keeping track of their everyday tasks, such as invoicing. stock, and
          so forth.
        </p>
        <button className="inner-btn" onClick={() => {
                      navto("/features");
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                        })}}>All Features</button>
      </motion.div>
      <motion.div
        className="col-xxl-5 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 row g-4 features-home2 "
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control1}
      >
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 main-box">
          <div className="text-center inner-box m-auto">
            <h6>Protection</h6>
            <svg
              width="101"
              height="100"
              viewBox="0 0 101 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.2871 74.2656L16.4121 81.1875H85.1621L88.2871 74.2656H13.2871Z"
                fill="#80D4C4"
              />
              <path
                d="M78.9277 29.2188H22.6465C20.0527 29.2188 17.959 31.3125 17.959 33.9063V74.2656H83.6309V33.9063C83.6152 31.3125 81.5215 29.2188 78.9277 29.2188Z"
                fill="#D2F0EA"
              />
              <path
                d="M77.3809 35.4688H24.209V68.0156H77.3809V35.4688Z"
                fill="#A38FD8"
              />
              <path
                d="M67.2246 32.3594H34.3496V68.0156H67.2246V32.3594Z"
                fill="#7C64BD"
              />
              <path
                d="M65.3809 23.4844L51.6309 18.9375C51.084 18.75 50.4902 18.75 49.9434 18.9375L36.1934 23.4844C35.084 23.8437 34.3496 24.875 34.3496 26.0313V43.1563C34.3496 46.75 36.0059 50.125 38.8184 52.3437L48.5684 59.9688C49.8652 60.9844 51.6934 60.9844 52.9902 59.9688L62.7402 52.3437C65.5684 50.1406 67.209 46.75 67.209 43.1563V26.0469C67.2246 24.8906 66.4746 23.8594 65.3809 23.4844Z"
                fill="#FBD872"
              />
              <path
                d="M63.7246 26.625V43.1719C63.7246 45.7031 62.584 48.0313 60.5996 49.6094L50.8496 57.2344L50.7871 57.25C50.7559 57.25 50.7402 57.2344 50.7402 57.2187L40.9746 49.5937C38.9746 48.0312 37.8496 45.6875 37.8496 43.1563V26.625L50.7871 22.3438L63.7246 26.625Z"
                fill="#F38E7A"
              />
              <path
                d="M47.2559 47.6875L41.5371 41.9844L44.584 38.9375L47.2559 41.6094L56.9902 31.8594L60.0371 34.9063L47.2559 47.6875Z"
                fill="white"
              />
            </svg>
            <p>Make GST invoices with app to avoid penalties.</p>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 main-box">
          <div className="text-center inner-box m-auto">
            <h6>Tracking</h6>
            <svg width="65" height="82" viewBox="0 0 65 82" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.6407 54.5234L5.6123 58.834L15.0886 81.3038L25.2089 76.9474L15.6407 54.5234Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M28.843 38.9336L18.8608 43.3817L31.9251 74.2893L41.9994 69.7953L28.843 38.9336Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M40.8949 20.6816L31.0508 25.2216L48.7151 67.1349L58.7435 62.5491L40.8949 20.6816Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.8124 17.5181C7.82022 27.9275 0 40.2631 0 40.2631L6.39425 44.482C6.39425 44.482 17.6185 25.9098 21.2067 21.1865L26.6348 24.2132V6.09961L9.79829 14.4914L14.8124 17.5181Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.0907 45.5371L9.24658 49.8477L18.5388 72.3635L28.3831 67.9613L19.0907 45.5371Z" fill="#FEC34E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.1549 69.3813L20.6087 41.7754L5.6582 48.3789L17.1126 76.0306L32.1549 69.3813ZM19.0907 45.5357L9.24634 49.8463L18.5386 72.3621L28.3829 67.9599L19.0907 45.5357Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.017 29.8984L22.1729 34.3465L35.0072 65.2999L44.8515 60.806L32.017 29.8984Z" fill="#31CEA8"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M48.5777 62.1823L33.4892 26.1387L18.6768 32.8797L33.6272 69.015L48.5777 62.1823ZM32.0172 29.899L22.1728 34.3471L35.0072 65.3005L44.8515 60.8066L32.0172 29.899Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.8851 11.6934L34.1328 16.2331L51.5212 58.2381L61.3655 53.6067L43.8851 11.785V11.6934Z" fill="#F38E7A"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M65.0002 54.9819L45.2655 7.88672L30.4531 14.8112L50.0037 61.9523L65.0002 54.9819ZM43.8396 11.6929L34.0873 16.2328L51.5217 58.2378L61.366 53.6062L43.8856 11.7847L43.8396 11.6929Z" fill="#2A2941"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5945 13.0233C7.9582 24.9004 0.644043 35.31 0.644043 35.31L7.5902 40.0789C7.5902 40.0789 18.6306 22.5616 22.5407 17.1964L28.4289 20.5898V0L10.1204 9.62992L15.5945 13.0233Z" fill="#F38E7A"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5945 13.0233C7.9582 24.9004 0.644043 35.31 0.644043 35.31L7.5902 40.0789C7.5902 40.0789 18.6306 22.5616 22.5407 17.1964L28.4289 20.5898V0L10.1204 9.62992L15.5945 13.0233ZM17.2504 14.078L18.3546 12.4272L14.0765 9.81346L26.5428 3.21V17.1964L22.0806 14.7201L21.0227 16.1417C17.8485 20.4981 9.93627 32.8335 7.08432 37.4193L3.40413 34.9431C5.70418 31.3661 11.4083 23.1119 17.2504 14.0322V14.078Z" fill="#2A2941"/>
</svg>

            <p>Make GST invoices with app to avoid penalties.</p>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 main-box">
          <div className="text-center inner-box m-auto">
            <h6>Notification</h6>
            <svg width="65px" height="65px" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M894.979186 760.898331a24.399187 24.399187 0 0 1-2.026269 9.812917c-7.850129 63.515702-94.981746 114.275841-236.662901 136.972307-46.901115 7.589038-97.596749 10.991409-146.78932 10.991409-48.598717 0-97.332587-3.14128-143.71152-10.532708-150.513191-23.483834-240.389844-78.363063-240.389845-146.785224 0-0.458701 0.130033-0.91433 0.19761-1.440607 0.324572-104.724015 51.741021-184.46318 123.171357-232.737325C260.215336 413.687555 309.930088 104.613435 510.090454 104.613435c0.066553 0 0.131057 0.066553 0.131057 0.066553 0.066553 0 0.131057-0.066553 0.19761-0.066553 199.835794 0 249.68058 307.96218 261.258675 421.976931 78.429616 52.856032 123.30139 138.218376 123.30139 234.307965z" fill="#27323A" /><path d="M193.035148 669.51759c73.851825-43.040044 197.417377-65.673029 316.465548-65.673029 120.360792 0 245.300398 23.156191 318.887037 67.113636-16.679092-41.404899-45.132865-76.858976-84.448014-103.287504-1.045387-0.783272-1.697602-1.831731-2.616027-2.746061-9.548755-2.749132-16.876702-10.991409-17.791032-21.457564-16.745644-188.191147-81.504344-389.268914-213.114563-389.268914-0.066553 0-0.131057-0.066553-0.19761-0.066553 0 0-0.063481 0.066553-0.131057 0.066553-121.145088 0-185.57512 170.463596-208.078071 344.397139 37.154751-15.436095 77.056586-23.809429 116.69733-23.809429 13.670917 0 24.726831 11.051818 24.72683 24.723759 0 13.670917-11.05489 24.793383-24.72683 24.793383-92.491657 0-187.208217 52.919513-225.673541 145.214584z" fill="#79CCBF" /><path d="M572.035516 805.184443c0-34.472171-28.062649-62.53482-62.598301-62.53482-34.472171 0-62.53482 28.062649-62.53482 62.53482 0 34.536676 28.062649 62.598301 62.53482 62.598301 34.536676 0 62.598301-28.062649 62.598301-62.598301z" fill="#FFFFFF" /><path d="M844.152495 761.357032c0-45.069384-127.293519-107.996352-334.651799-107.996352-206.178764 0-333.081159 62.206153-334.454189 107.212056v0.324572c0 0.19761-0.131057 0.328667-0.131058 0.526277 0.066553 33.227127 68.225575 77.448734 198.526246 97.791287 12.824164 2.026269 26.427504 3.596909 40.297054 5.037516-10.663766-17.204345-17.074312-37.352361-17.074311-59.068969 0-62.206153 50.565601-112.771754 112.771753-112.771753s112.835234 50.565601 112.835235 112.771753c0 21.715584-6.474027 41.864623-17.137793 59.068969 14.390708-1.507159 28.453773-3.14128 41.670085-5.235126 128.470987-20.53914 197.348777-64.82218 197.348777-97.66023z" fill="#F4CE73" /><path d="M501.128386 240.869023c-38.592286 0-82.679764 76.795495-84.642552 130.890428-0.458701 13.670917-11.969219 24.334683-25.641161 23.875982-13.670917-0.522182-24.334683-11.970243-23.875981-25.64116 2.616027-71.955589 60.04985-178.642392 134.159694-178.642392 13.670917 0 24.793383 11.055914 24.793383 24.72683s-11.122466 24.790311-24.793383 24.790312z" fill="#27323A" /></svg>

            <p>Make GST invoices with app to avoid penalties.</p>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 main-box">
          <div className="text-center inner-box m-auto">
            <h6>Easiness</h6>
            <svg
              width="66"
              height="65"
              viewBox="0 0 66 65"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M59.074 37.475C60.1154 36.2869 60.8017 34.7713 60.8017 33.0991C60.8017 28.7926 57.2986 25.2894 52.9941 25.2894H43.0244C40.8344 25.1883 40.3008 24.7736 40.279 24.7559L40.2611 24.732C40.3206 24.1527 41.3243 22.7364 41.8163 22.0462C42.5225 21.0543 43.189 20.1161 43.5699 19.0747L43.7385 18.6184C44.7125 15.998 46.5275 11.1202 44.5597 5.51446C43.3675 2.11453 40.7153 0 37.6408 0C34.0603 0 31.0829 2.86444 30.4024 6.96858C30.1743 8.3492 27.1472 13.5543 21.3689 20.3483C19.7701 22.2289 17.967 23.7919 16.0588 25.4462C14.5512 26.7514 12.9921 28.1003 11.3397 29.7527C7.00535 34.085 4.94236 41.4304 6.08303 48.4604C7.06895 54.5463 10.2447 59.2118 15.0254 61.6021C18.9411 63.56 26.5443 64.6549 32.3425 64.8691C34.7685 64.9584 36.5975 65 38.0971 65C40.9654 65 42.3916 64.8393 44.1968 64.635L44.8058 64.5676L44.909 64.5557L47.8388 64.1311L47.8944 64.1231C51.6892 63.5042 54.4424 60.2709 54.4424 56.4345L54.4364 56.1587C56.6523 54.7841 58.0943 52.3402 58.0943 49.5532C58.0943 48.609 57.9495 47.7878 57.6996 47.0756C59.2132 45.6513 60.1554 43.634 60.1554 41.4124C60.1552 39.9942 59.7644 38.6414 59.074 37.475ZM53.1984 37.9907H55.4835C56.4178 38.8357 57.009 40.0498 57.009 41.4125C57.009 42.8665 56.3287 44.148 55.2813 44.9969H52.2186C51.6393 44.9969 51.1712 45.4651 51.1712 46.0442C51.1712 46.6234 51.6394 47.0936 52.2186 47.0936H54.1309C54.7656 47.8057 54.9482 48.6468 54.9482 49.5534C54.9482 50.9995 54.2757 52.2769 53.2382 53.1239H50.2926C49.7114 53.1239 49.2432 53.594 49.2432 54.1733C49.2432 54.7526 49.7114 55.2207 50.2926 55.2207H51.1217C51.2328 55.6075 51.2962 56.0121 51.2962 56.4347C51.2962 58.7516 49.6042 60.6559 47.3885 61.017L44.4587 61.4415C42.3361 61.6756 41.0905 61.8541 38.0972 61.8541C36.6927 61.8541 34.9035 61.8144 32.4597 61.7232C26.9193 61.5189 19.812 60.4774 16.4319 58.7874C6.96993 54.0564 6.96396 38.578 13.5655 31.9764C17.2927 28.2492 20.7344 25.954 23.7654 22.3875C28.4489 16.8789 33.0351 10.3389 33.5071 7.48249C33.9712 4.68152 35.7902 3.14628 37.641 3.14628C39.1962 3.14628 40.7753 4.23135 41.5925 6.55814C43.2944 11.4102 41.4397 15.7305 40.6164 17.9919C39.7873 20.2573 35.215 23.935 38.002 26.9242C39.0374 28.0351 41.0707 28.3564 42.9552 28.4378H52.9944C55.5711 28.4378 57.656 30.5246 57.656 33.0993C57.656 34.2003 57.0331 35.1901 56.2079 35.8923H53.1986C52.6193 35.8923 52.1492 36.3605 52.1492 36.9397C52.1492 37.5188 52.6192 37.9907 53.1984 37.9907Z"
                fill="#F38E7A"
              />
            </svg>

            <p>Make GST invoices with app to avoid penalties.</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default FeaturesHome;
